import React, { useCallback, useState } from "react";
import { FilterMode } from "./Filtermode";
import BasicGrid from "./Grid";

const BarCodeLiquidationAgeingStore = () => {

  const [lastPayload, setLastPayload] = useState(null);

  return (
    <>
      <FilterMode onSearch={setLastPayload} />
      <BasicGrid onRefresh={lastPayload} />
    </>
  );
};

export default BarCodeLiquidationAgeingStore;
